import {createSelector} from 'reselect';
import {CommonRootState} from '../types';

export const selectMyAcuriteConnectedAt = (state: CommonRootState) =>
  state.myAcurite.link && state.myAcurite.link.date_connected;

export const selectMyAcuriteConnected = (state: CommonRootState) =>
  state.myAcurite.link !== null;

export const selectMyAcuriteActive = (state: CommonRootState) =>
  state.myAcurite.link !== null && state.myAcurite.link.account.active;

const selectMyAcuriteLink = (state: CommonRootState) => state.myAcurite.link;

export const getMyAcuriteStationList = createSelector(
  selectMyAcuriteLink,
  (link) => {
    if (link !== null) {
      return link.account.weather_stations;
    }
    return [];
  },
);

const getRawCurrentStationId = (state: CommonRootState) =>
  state.myAcurite.currentStation;

export const getCurrentMyAcuriteStation = createSelector(
  getRawCurrentStationId,
  getMyAcuriteStationList,
  (stationId, stationList) => {
    if (stationList.length === 0) {
      return null;
    }
    const currentStation = stationId
      ? stationList.find((item) => item.device_id === stationId) ||
        stationList[0]
      : stationList[0];

    return currentStation;
  },
);
